var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,12.75c-2.481,0-4.5-2.019-4.5-4.5s2.019-4.5,4.5-4.5c2.481,0,4.5,2.019,4.5,4.5S14.481,12.75,12,12.75z M12,5.25 c-1.654,0-3,1.346-3,3s1.346,3,3,3c1.654,0,3-1.346,3-3S13.654,5.25,12,5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.998,24.001c-0.294,0-0.58-0.087-0.827-0.25c-0.168-0.111-0.309-0.253-0.421-0.421 c-0.702-1.057-2.448-3.866-4.039-6.925C4.746,12.625,3.75,9.882,3.75,8.25C3.75,3.701,7.451,0,12,0s8.25,3.701,8.25,8.25 c0,1.631-0.996,4.375-2.961,8.155c-1.59,3.058-3.337,5.867-4.039,6.925c-0.221,0.334-0.56,0.562-0.952,0.641 C12.199,23.991,12.098,24.001,11.998,24.001z M12,1.5c-3.722,0-6.75,3.028-6.75,6.75c0,2.88,4.396,10.702,6.75,14.25 c2.354-3.548,6.75-11.371,6.75-14.25C18.75,4.529,15.722,1.5,12,1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.10df85f4408033e264b010bad6ba4986.svg";
export { ForwardRef as ReactComponent };